/**
 * Currency utilities for safe integer-based financial aggregation.
 *
 * JavaScript floating-point arithmetic is imprecise (0.1 + 0.2 !== 0.3).
 * These helpers convert dollar values to integer cents for aggregation,
 * then back to formatted dollar strings for display.
 */

/**
 * Convert a dollar value (float from backend) to integer cents.
 * Safe for addition — integer math is always exact.
 * @param {number|string|null|undefined} val - Dollar value (e.g. 650.00)
 * @returns {number} Integer cents (e.g. 65000)
 */
export const toCents = (val) => Math.round(parseFloat(val || 0) * 100);

/**
 * Convert integer cents back to a formatted dollar string.
 * @param {number} cents - Integer cents (e.g. 65000)
 * @returns {string} Formatted dollar string (e.g. "650")
 */
export const toDollars = (cents) =>(cents / 100);


/**
 * Convert integer cents back to a formatted dollar string.
 * @param {number} cents - Integer cents (e.g. 65000)
 * @returns {string} Formatted dollar string (e.g. "$650.00")
 */
export const toDollarsPretty = (cents) => '$' + (cents / 100).toFixed(2);

